import config from "../nyConfig";
const ApiPrework = {
  题目列表: new config({
    url: "/manager/prejob/pagePreJob",
    showSuccessMessage: false,
    useToken: true,
  }),
  添加题目: new config({
    url: "/manager/prejob/addPreJob",
    showSuccessMessage: true,
    useToken: true,
  }),
  编辑题目: new config({
    url: "/manager/prejob/editPreJob",
    showSuccessMessage: true,
    useToken: true,
  }),
  删除题目: new config({
    url: "/manager/prejob/delPreJob",
    showSuccessMessage: true,
    useToken: true,
  }),
  添加规则: new config({
    url: "/manager/prejob/addRule",
    showSuccessMessage: true,
    useToken: true,
  }),
  编辑规则: new config({
    url: "/manager/prejob/editRule",
    showSuccessMessage: true,
    useToken: true,
  }),
  规则列表: new config({
    url: "/manager/prejob/listRule",
    showSuccessMessage: true,
    useToken: true,
  }),
  获得岗前测评信息: new config({
    url: "/manager/prejob/preJobInfo",
    showSuccessMessage: false,
    useToken: true,
  }),
  编辑岗前测评信息: new config({
    url: "/manager/prejob/editPreJobInfo",
    showSuccessMessage: true,
    useToken: true,
  }),
};

export default ApiPrework;
